(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ucw-shop-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ucw-shop-carousel'))customElements.define('ucw-shop-carousel',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.ucw-shop-reviews__grid');if(!this.track)return;
  this.controller=new AbortController();const options={signal:this.controller.signal};
  this.previous=this.querySelector('[data-review-prev]');this.next=this.querySelector('[data-review-next]');
  const update=()=>{this.previous.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;};
  const move=direction=>{const card=this.track.firstElementChild;const step=card?card.getBoundingClientRect().width+16:this.track.clientWidth;this.track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  this.previous.addEventListener('click',()=>move(-1),options);this.next.addEventListener('click',()=>move(1),options);this.track.addEventListener('scroll',update,{...options,passive:true});
  this.observer=new ResizeObserver(update);this.observer.observe(this.track);update();
 }
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();
})();
